import React, { useMemo } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Icon from 'components/UI/Icon'
import TimeSlotTooltip from './TimeSlotTooltip'

import { selectStudentCalendarData } from '../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { calendarTooltips, classStatuses } from '../../../constants'

const TimeSlotWrapper = ({ children: { props }, value, onClick }) => {
  const location = useLocation()

  const userCalendarData = useSelector(selectStudentCalendarData)

  const isTutor = location.pathname.includes('tutor')

  const timeDetector = useMemo(() => {
    const key = `${moment(value).format('YYYY-MM-DD')}:${moment(value).format('H')}`

    if (!userCalendarData[key]) {
      return { isEmpty: true }
    }

    const categoryName =
      userCalendarData[key].availability_calendar_detail.class_banner.class_banner_category.name
    const slotStatus = userCalendarData[key].status
    const statusData = classStatuses[slotStatus] || classStatuses.cancelled

    if (statusData.title === classStatuses.cancelled.title) {
      return { isEmpty: true }
    }

    return {
      ...{ hasInitialEvent: true },
      title: categoryName,
      statusData: classStatuses[slotStatus] || classStatuses.cancelled,
    }
  }, [value])

  // function getClassBanner () {
  //   try {
  //     return lastBanner?.id;
  //   } catch (err) {
  //     return null
  //   }
  // }
  //
  // const onAddEvent = () => {
  //   if (!timeDetector.hasInitialEvent) {
  //     dispatch(toggleNewCreatedEvent({
  //       class_banner: getClassBanner(),
  //       day: moment(value).format('YYYY-MM-DD'),
  //       slot: moment(value).format('H'),
  //       notes: ''
  //     }));
  //   }
  // }

  if (props.children) {
    return (
      <span className="text-xs font-medium text-[#F67443]">{moment(value).format('HH:mm')}</span>
    )
  }

  return (
    <div className="py-[6px] px-[10px] absolute w-full h-full">
      <div
        className={`group w-full h-full ${timeDetector.status === 'pending' ? '' : timeDetector.hasInitialEvent && timeDetector.isEmpty && !onClick ? 'pointer-events-none' : 'cursor-pointer'} ${timeDetector.isEmpty ? '' : `${timeDetector.statusData.background}`} flex items-center justify-center rounded-lg`}
        onClick={
          !timeDetector.isEmpty && onClick ? () => onClick({ ...timeDetector, value }) : undefined
        }
      >
        {!timeDetector.isEmpty && (
          <div className="inline-flex items-center justify-center">
            <span className="font-semibold text-base text-white font-Inter">
              {timeDetector.title}
            </span>

            {timeDetector.status === 'pending' && (
              <TimeSlotTooltip
                title={
                  <span className="text-sm font-medium text-[#F67443] font-Inter whitespace-pre-line">
                    {isTutor ? calendarTooltips.tutor : calendarTooltips.student}
                  </span>
                }
              >
                <div className="ml-[9px]">
                  <Icon name="information-fill" width={13} height={13} className="text-white" />
                </div>
              </TimeSlotTooltip>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default React.memo(TimeSlotWrapper)
